import { createSlice } from '@reduxjs/toolkit';
// import { checkTokenValidity } from '../data/auth'

const initialState = {
  isAuthenticated: false,
  token: localStorage.getItem('Mytoken') || null,
  user: '',
  id: '',
  routes: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.id = action.payload.id;
      state.routes = action.payload.routes;
      localStorage.setItem('token', action.payload.token);
    },
    logout: state => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.routes = [];
      localStorage.removeItem('token');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
